export type Branding = {
  appName: string;
  orgName: string;
  loginTagline: string;
  loginHeroHeadline: string;
  loginHeroText: string;
  supportEmail: string;
  /**
   * Public URL of the admin-uploaded workspace logo, or null when none has
   * been uploaded (consumers fall back to the bundled logo mark). Sourced
   * from the `workspace` table by GET /api/branding, not from env.
   */
  logoUrl: string | null;
};

export const DEFAULT_BRANDING: Branding = {
  appName: "Project Manager",
  orgName: "Project Manager",
  loginTagline: "INTERNAL TOOL",
  loginHeroHeadline: "A home for your team's work.",
  loginHeroText:
    "Project management on your own Cloudflare account, costing close to zero dollars per month.",
  supportEmail: "support@example.com",
  logoUrl: null,
};
